import { message } from "antd";

export function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
    }

    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error("Image must smaller than 2MB!");
    }

    return isJpgOrPng && isLt2M;
}

export function checkPermission(data, code, permission) {
    const obj = data.find(item => item.code === code);

    if (obj) {
        const func = obj.functions.find(func => func.code === permission);
        return func !== undefined; // Mengembalikan true jika izin ditemukan, false jika tidak
    }

    return false;
}

export const getTodayDateString = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};

export const PASSWORD_POLICY_MESSAGE =
    "Password must be at least 8 characters with contains uppercase, lowercase, number and special character";

export function validatePasswordPolicy(password) {
    if (!password || password.length < 8) {
        return false;
    }
    if (!/[a-z]/.test(password)) {
        return false;
    }
    if (!/[A-Z]/.test(password)) {
        return false;
    }
    if (!/\d/.test(password)) {
        return false;
    }
    if (!/[^A-Za-z0-9]/.test(password)) {
        return false;
    }
    return true;
}